import React, {
    useCallback,
    useEffect,
    useState
} from "react";
import axios from "axios";
import {
    Alert
} from "react-bootstrap";

import Loading from "../Loading";
import EventCard from "./EventCard";
import EventInviteCard from "./EventInviteCard";

function DiscoverList() {
    const [sections, setSections] = useState(null);
    const [error, setError] = useState(null);
    const [openEventInvites, setOpenEventInvites] = useState(null);
    const [openInvitesError, setOpenInvitesError] = useState(null);

    const getOpenInvites = useCallback(async () => {
        setOpenInvitesError(null);
        try {
            const response = await axios.get("/getOpenEventInvites");
            setOpenEventInvites(response.data.eventInvites);
        } catch(requestError) {
            console.error(requestError);
            setOpenInvitesError("Er ging iets fout bij het ophalen van de openstaande uitnodigingen. Probeer het later opnieuw.");
        }
    }, []);

    const refreshEvents = useCallback(async () => {
        setError(null);
        setSections(null);
        try {
            const response = await axios.get("/getDiscoverEvents");
            setSections(response.data.sections);
        } catch(requestError) {
            console.error(requestError);
            setError("Er ging iets fout bij het ophalen van de evenementen. Probeer het later opnieuw.");
        }
    }, []);

    useEffect(() => {
        refreshEvents();
        getOpenInvites();
    }, [refreshEvents, getOpenInvites]);

    return (
        <React.Fragment>
            <h1 className="text-white text-center mt-3 mb-2">
                Ontdek
            </h1>
            { openInvitesError ? (
                <Alert variant="danger">{ openInvitesError }</Alert>
            ) : !openEventInvites ? (
                <Loading white/>
            ) : openEventInvites.length > 0 ? (
                <div className="container">
                    <h5 className="text-white mt-3">
                        Open uitnodigingen voor evenementen
                    </h5>
                    <div>
                        { openEventInvites.map((eventInvite) => (
                            <div key={eventInvite.id} className="w-100">
                                <EventInviteCard eventInvite={eventInvite}/>
                            </div>
                        ))}
                    </div>
                </div>
            ) : null }
            { error ? (
                <Alert variant="danger">{ error }</Alert>
            ) : !sections ? (
                <Loading white/>
            ) : (
                <div className="container">
                    { sections.map((section, index) => (
                        <React.Fragment key={ index }>
                            <h5 className="text-white mt-3">
                                { section.title }
                            </h5>
                            <div className="row">
                                { section.events?.map((event) => (
                                    <div key={event.id} className="col-sm-6 col-xl-4">
                                        <EventCard event={event}/>
                                    </div>
                                ))}
                            </div>
                        </React.Fragment>
                    ))}
                </div>
            )}
        </React.Fragment>
    );
}

export default React.memo(DiscoverList);
